import { useState } from 'react';
import { useSnackbar } from 'notistack';
import { API_DOMAIN } from '../../../../constants';
import {
  downloadOrderItemsXlsx,
  downloadOrdersItemsXlsx,
  downloadOrderXlsx,
} from '../../../../crud/orders.crud';

interface IDownloadOrderXlsxResponse {
  data: {
    link: string;
  };
}

export function useDownloadOrderXlsx() {
  const [loadingIds, setLoadingIds] = useState<number[]>([]);
  const [loadingOrderIds, setLoadingOrderIds] = useState<number[]>([]);
  const { enqueueSnackbar } = useSnackbar();

  const openFile = (fileLink: string) => {
    window.open(`${API_DOMAIN}${fileLink}`, '_blank');
  };

  const downloadById = async (id: number) => {
    const response = await downloadOrderXlsx(id);
    const data = response.data as IDownloadOrderXlsxResponse;
    openFile(data.data.link);
  };

  const downloadItemsOrderById = async (id: number) => {
    const response = await downloadOrderItemsXlsx(id);
    const data = response.data as IDownloadOrderXlsxResponse;
    openFile(data.data.link);
  };

  const downloadItemsOrdersById = async (id: number) => {
    const response = await downloadOrdersItemsXlsx(id);
    const data = response.data as IDownloadOrderXlsxResponse;
    openFile(data.data.link);
  };

  const download = async (id: number) => {
    setLoadingIds(prev => [...prev, id]);
    try {
      await downloadById(id);
    } catch {
      enqueueSnackbar('Не удалось сформировать файл', { variant: 'error' });
    } finally {
      setLoadingIds(prev => prev.filter(item => item !== id));
    }
  };

  const downloadOrder = async (id: number) => {
    setLoadingOrderIds(prev => [...prev, id]);
    try {
      await downloadItemsOrderById(id);
    } catch {
      enqueueSnackbar('Не удалось сформировать файл', { variant: 'error' });
    } finally {
      setLoadingOrderIds(prev => prev.filter(item => item !== id));
    }
  };

  const downloadOrders = async (id: number) => {
    setLoadingOrderIds(prev => [...prev, id]);
    try {
      await downloadItemsOrdersById(id);
    } catch {
      enqueueSnackbar('Не удалось сформировать файл', { variant: 'error' });
    } finally {
      setLoadingOrderIds(prev => prev.filter(item => item !== id));
    }
  };

  return { download, loadingIds, loadingOrderIds, downloadOrder, downloadOrders };
}
